﻿import { useEffect } from 'react';

import { GenerateReport } from 'components/GenerateReport/GenerateReport';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { TileContainer } from 'components/TileContainer/TileContainer';
import { exportPDF } from 'pages/groups/components/Activity/exportPDF';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { useGroupDetails } from 'pages/groups/context';
import { ReportFilterType } from 'apis/ReportApi';
import { FormattedMessage } from 'react-intl';
import { JoyrideApi } from 'apis/JoyrideApi';
import { useJoyride } from 'app/joyride';
import { useSuperState } from 'hooks';
import { useApp } from 'app';

import 'pages/groups/components/Activity/styles/activity.scss';

export const Activity = props => {

    const [state, setState] = useSuperState({
        runState: true,
        showTour: false,
        waitForDataLoad: false
    });

    const { selectedPartner } = useApp();
    const { pageContext } = useGroupDetails();
    const { currentTour, loadCurrentTour } = useJoyride();

    const handleJoyrideCallback = async (data: any) => {

        // This callback is fired with every state change of the Joyride component.
        // The data parameter provides lots of useful information, which we can use in conditional
        const { action, index, status, type } = data;

        // Handle what to do when the tour is finished or skipped:
        if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {

            if (data.type == 'tour:end') {

                if (currentTour) {

                    try {

                        await JoyrideApi.SetJoyrideIntroComplete(currentTour?.Claim);
                        setState({
                            runState: false,
                            showTour: false
                        });

                    } catch (error: any) {

                        console.error(error.Message);

                    }

                }

            }

            // Handle what to do when a Joyride button is clicked (eg 'Next', close, 'Back', etc), or if a Joyride button is clicked and the target for the next step doesn't exist.

        } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {

            if (data.action == 'close') {

                setState({ runState: false });
                if (currentTour) {

                    try {

                        await JoyrideApi.SetJoyrideIntroComplete(currentTour?.Claim);
                        setState({ runState: false, showTour: false });

                    } catch (error: any) {

                        console.error(error.Message);

                    }

                }

            } else {

                // if the current action is 'previous', set the stepIndex back one, otherwise progress +1:
                const stepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

            }

        }

    };

    useEffect(() => {

        loadCurrentTour('reportstab');
        setTimeout(() => {

            setState({ waitForDataLoad: true });

        }, 500);

    }, []);

    useEffect(() => {

        if (currentTour && currentTour.ClaimValue == null) {

            setState({ showTour: true });

        }

    }, [currentTour]);

    return (
        <>
            {currentTour && state.showTour && (
                <Joyride
                    continuous
                    styles={{
                        options: {
                            zIndex: 10000
                        }
                    }}
                    callback={handleJoyrideCallback}
                    disableOverlayClose={true}
                    disableScrolling={true}
                    hideBackButton={true}
                    run={state.runState}
                    steps={currentTour?.Steps}
                />
            )}
            <TileContainer
                addButton
                addButtonCustom={(
                    <GMetrixButton
                        iconClass="fa-solid fa-print"
                        onClick={() => exportPDF()}
                        type="button"
                        variant="primary"
                    >
                        <FormattedMessage defaultMessage="Print" id="print.1fd3b13a" />
                    </GMetrixButton>
                )}
            >
                <div id="reportPDF">
                    {state.waitForDataLoad && pageContext && (
                        <GenerateReport
                            propCustomFilter={{
                                filterId: ReportFilterType.StudentGroupsCSV,
                                valueId: pageContext.Id
                            }}
                            autoRunReport={true}
                            removeFilters={['TransactionsCSV', 'StudentGroupsCSV']}
                            reportId={30}
                            scopeId={4}
                            scopeObjectId={selectedPartner.id}
                        />
                    )}
                </div>
            </TileContainer>
        </>
    );

};
